export default {
  device_authenticated_result: {
    authentication_results: '认证结果',
    id: 'ID',
    key: 'Key',
    request_time: '请求时间',
    title: '充电桩{0}认证历史'
  }
}
